<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">

    <ng-container *ngIf="isLoading; else content">
      <div class="spinner-wrap">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>

    <ng-template #content>
      <section class="hero">
        <h1 class="title">Escolha o estilo da sua capa</h1>
        <p class="subtitle">
          Escolha entre os estilos, a capa que mais combina com seu livro
        </p>
      </section>

      <!-- Carrossel 1: Capas -->
      <section class="carousel-section">
        <div class="carousel-header">
          <div class="carousel-label">
            <span class="label-strong">Capas</span>
            <span class="label-weak">— escolha um modelo base</span>
          </div>
        </div>

        <div class="carousel-wrap">
          <button class="nav-btn left" type="button" (click)="scrollCovers('left')" aria-label="Voltar capas">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <div #coverTrack class="track" role="list">
            <div
              *ngFor="let c of listBookCover; let i = index"
              class="card cover-card"
              [class.selected]="i === selectedCoverIndex"
              (click)="selectCover(i)"
              [attr.data-idx]="i"
              role="listitem"
            >
              <div class="img-wrap" (click)="$event.stopPropagation(); openImage(c.bookCoverUrl)">
                <img [src]="c.bookCoverUrl" [alt]="c.bookCoverName" />
              </div>

              <div class="meta">
                <div class="name">{{ c.bookCoverName }}</div>
                <div class="desc">{{ c.bookCoverDescription }}</div>
              </div>

              <div class="selected-badge" *ngIf="i === selectedCoverIndex">
                Selecionado
              </div>
            </div>
          </div>

          <button class="nav-btn right" type="button" (click)="scrollCovers('right')" aria-label="Avançar capas">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </section>

      <!-- Carrossel 2: Estilos -->
      <section class="carousel-section" *ngIf="selectedCover as sc">
        <div class="carousel-header">
          <div class="carousel-label">
            <span class="label-strong">{{ sc.bookCoverName }}</span>
            <span class="label-weak">— escolha um estilo</span>
          </div>
        </div>

        <div class="carousel-wrap">
          <button class="nav-btn left" type="button" (click)="scrollStyles('left')" aria-label="Voltar estilos">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <div #styleTrack class="track" role="list">
            <div
              *ngFor="let s of stylesForSelectedCover; let j = index"
              class="card style-card"
              [class.selected]="j === selectedStyleIndex"
              (click)="selectStyle(j)"
              [attr.data-idx]="j"
              role="listitem"
            >
              <div class="img-wrap" (click)="$event.stopPropagation(); openImage(s.bookCoverStyleUrl)">
                <img [src]="s.bookCoverStyleUrl" [alt]="s.bookCoverStyleName" />
              </div>

              <div class="meta">
                <div class="name">{{ s.bookCoverStyleName }}</div>
                <div class="desc">{{ s.bookCoverStyleDescription }}</div>
              </div>

              <div class="selected-badge" *ngIf="j === selectedStyleIndex">
                Selecionado
              </div>
            </div>

            <div class="empty-state" *ngIf="stylesForSelectedCover.length === 0">
              Nenhum estilo disponível para esta capa.
            </div>
          </div>

          <button class="nav-btn right" type="button" (click)="scrollStyles('right')" aria-label="Avançar estilos">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <!-- Resumo -->
        <div class="choice-box">
          <div class="choice-title">Sua escolha</div>

          <div class="choice-row">
            <div class="choice-item">
              <div class="choice-label">Capa</div>
              <div class="choice-value">{{ sc.bookCoverName }}</div>
            </div>

            <div class="choice-item">
              <div class="choice-label">Estilo</div>
              <div class="choice-value">
                {{ selectedStyle?.bookCoverStyleName || 'Nenhum selecionado' }}
              </div>
            </div>

            <div class="choice-thumb" *ngIf="selectedStyle?.bookCoverStyleUrl">
              <img [src]="selectedStyle!.bookCoverStyleUrl"
                   alt="Prévia do estilo selecionado"
                   (click)="openImage(selectedStyle!.bookCoverStyleUrl)" />
            </div>
          </div>
        </div>
      </section>

      <!-- Ações principais -->
      <section class="actions">
        <button class="btn secondary" type="button" (click)="voltar()">Voltar</button>

        <button class="btn primary"
                type="button"
                [disabled]="!canAdvance || isSaving"
                (click)="avancar()">
          <span class="btn-spinner" *ngIf="isSaving"></span>
          <span *ngIf="!isSaving">{{ selectedStyle ? 'Continuar' : 'Avançar' }}</span>
          <span *ngIf="isSaving">Salvando...</span>
        </button>
      </section>

      <!-- Alternativas -->
      <section class="alt-actions">
        <div class="alt-col">
          <div class="alt-title">Já tem uma capa? Faça o upload (PDF)</div>

          <input #fileInput type="file" accept="application/pdf,.pdf" style="display:none" (change)="onFileSelected($event)" />

          <button class="btn green" type="button" (click)="onUploadClick()">Fazer upload</button>

          <div class="upload-info" *ngIf="uploadedPdfServerFileName">
            <div class="upload-line">
              <mat-icon class="pdf-ico">picture_as_pdf</mat-icon>
              <span class="upload-name">{{ uploadedPdfServerFileName }}</span>
              <span class="upload-size">{{ uploadedPdfSizeLabel }}</span>

              <button class="link-btn" type="button" (click)="openPdf()" *ngIf="uploadedPdfBlobUrl">abrir</button>
              <button class="link-btn" type="button" (click)="clearUpload()">remover</button>
            </div>

            <div class="pdf-hint">
              PDF selecionado. Você pode avançar para concluir o envio no próximo passo.
            </div>
          </div>
        </div>

        <div class="alt-col">
          <div class="alt-title">Prefere a ajuda de um profissional?</div>
          <button class="btn green" type="button" (click)="onHireDesignerClick()">Designer feira do livro</button>

          <div class="hire-info" *ngIf="coverService">
            Solicitação de designer registrada.
          </div>
        </div>
      </section>
    </ng-template>

  </div>
</div>

<!-- Overlay imagens -->
<div class="image-overlay" *ngIf="expandedImage" (click)="closeImage()">
  <img [src]="expandedImage" class="expanded-image" (click)="$event.stopPropagation()" />
  <button class="close-btn" (click)="closeImage()">✕</button>
</div>

<app-footer></app-footer>
